import React from 'react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, Typography } from '@material-ui/core';
import SearchField from '../../Util/SearchField';
import SelectMultiple, { OptionType } from '../../Util/SelectMultiple';
import { isArray } from 'underscore';
import { PeriodTypeToString } from '../SessionPeriods';
import { PeriodType } from '../../../api';
import SessionLabelExport from './SessionLabelExport';
import { TSession } from '../Sessions';
import { RunData, EvictionStatus } from './sessionLabelOverviewReducer';
import { LabelTask } from '../../../services/sessionModels';
import SessionRunEvict from '../SessionLabelEvict';
import SessionAddLabelTaskButton from './SessionAddLabelTaskButton';

interface Props {
  refetch: () => void;
  session?: TSession;
  labelTasks?: LabelTask[];
  runData?: RunData;
  search?: string;
  onSearchChange: (val: string) => void;
  types: Array<string>;
  onTypesChange: (types: Array<string>) => void;
  periods: Array<string>;
  onPeriodsChange: (periods: Array<string>) => void;
  unfinishedOnly: boolean;
  onChangeUnfinishedOnly: (unfinishedOnly: boolean) => void;
  mineOnly: boolean;
  onChangeMineOnly: (mineOnly: boolean) => void;
  unassignedOnly: boolean;
  onChangeUnassignedOnly: (unassignedOnly: boolean) => void;
}

const option = (value: string) => {
  return {
    value: value,
    label: value,
  };
};

const periodOption = (value: PeriodType) => {
  return {
    value: PeriodTypeToString(value),
    label: PeriodTypeToString(value),
  };
};

const LabelTasksFilter: React.FunctionComponent<Props> = (props) => {
  const onTypesChange = (value: ReadonlyArray<OptionType> | OptionType | null | undefined) => {
    return value && isArray(value) ? props.onTypesChange(value.map((v) => v.value)) : props.onTypesChange([]);
  };

  const onPeriodsChange = (value: ReadonlyArray<OptionType> | OptionType | null | undefined) => {
    return value && isArray(value) ? props.onPeriodsChange(value.map((v) => v.value)) : props.onPeriodsChange([]);
  };

  return (
    <div className="sciui-bg-p-4 sciui-m-y-m sciui-p-m">
      <div className="sciui-m-y-m">
        <Typography variant="h4">Filter</Typography>
      </div>
      <SearchField key="search" value={props.search} onChange={props.onSearchChange} />
      <SelectMultiple
        data={[option('Ball'), option('Goalkeeper'), option('Official'), option('Player')]}
        selected={props.types.map((t) => option(t))}
        label="Task type"
        placeholder="Select task type"
        onChange={onTypesChange}
      />
      <SelectMultiple
        data={[
          periodOption(PeriodType.FirstHalf),
          periodOption(PeriodType.SecondHalf),
          periodOption(PeriodType.ExtraTimeFirstHalf),
          periodOption(PeriodType.ExtraTimeSecondHalf),
          periodOption(PeriodType.Penalties),
          periodOption(PeriodType.Other),
        ]}
        selected={props.periods.map((p) => {
          return { value: p, label: p };
        })}
        label="Period"
        placeholder="Select period"
        onChange={onPeriodsChange}
      />
      <FormControl component="fieldset">
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                onChange={(evt, checked) => props.onChangeUnfinishedOnly(checked)}
                value={props.unfinishedOnly}
              />
            }
            label="Unfinished tasks"
          />
          <FormControlLabel
            control={
              <Checkbox
                disabled={props.unassignedOnly}
                onChange={(evt, checked) => props.onChangeMineOnly(checked)}
                value={props.mineOnly}
              />
            }
            label="My tasks"
          />
          <FormControlLabel
            control={
              <Checkbox
                disabled={props.mineOnly}
                onChange={(evt, checked) => props.onChangeUnassignedOnly(checked)}
                value={props.unassignedOnly}
              />
            }
            label="Unassigned tasks"
          />
        </FormGroup>
      </FormControl>
      <SessionLabelExport refetch={props.refetch} session={props.session} labelTasks={props.labelTasks} runData={props.runData} />
      <SessionRunEvict runId={props.session?.lastRun?.id || ""} nextState={EvictionStatus.Evicting} />
      <SessionAddLabelTaskButton sessionId={props.session ? String(props.session.id) : ""} />
    </div>
  );
};

export default LabelTasksFilter;
